import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

import { Add as AddIcon } from '@mui/icons-material';
import { Box, Skeleton, useTheme } from '@mui/material';

import CustomButton from 'components/Button';
import { JOB_MODAL, projectModalActions } from 'features/Project/projectModalSlice';
import { projectFilterActions } from 'features/Project/projectSlice';
import { ProjectManagementJobResponse } from 'types/ProjectTypes';

import JobLineItem from '../components/JobLineItem';
interface ProjectJobListProps {
  isLoading: boolean;
  projectJobs: ProjectManagementJobResponse[] | [];
}

/**
 *
 * @returns Returns Project Management Job List Page
 */
const ProjectJobList = ({ isLoading, projectJobs }: ProjectJobListProps) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { assignee } = useSelector((state: RootState) => state.projectFilterReducer);

  // If the selected assignee no longer has any tasks across all jobs, fall back to 'All'.
  React.useEffect(() => {
    if (assignee === 'All') return;
    const hasTasks = (projectJobs ?? []).some((job) => job.task_list?.some((task) => task.assigned_to_id === assignee));
    if ((projectJobs?.length ?? 0) > 0 && !hasTasks) {
      dispatch(projectFilterActions.setAssignee('All'));
    }
  }, [assignee, projectJobs, dispatch]);

  return (
    <>
      {isLoading ? (
        <>
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton key={index} variant="rectangular" animation="wave" width="100%" height="56px" />
          ))}
        </>
      ) : (projectJobs?.length ?? 0) > 0 ? (
        <>
          {projectJobs?.map((job) => (
            <JobLineItem key={job.job_id} jobItem={job} />
          ))}
        </>
      ) : (
        <Box sx={{ flex: 1 }}>
          <CustomButton
            variant="outlined"
            text="Add new a job"
            width="100%"
            height="90vh"
            toolTip="Add new job to get started"
            endIcon={
              <AddIcon sx={{ color: theme.palette.busmanColors.lightGrey, width: '15px', fontWeight: 'bold' }} />
            }
            onClick={() => dispatch(projectModalActions.openAddModal({ type: JOB_MODAL }))}
            customSx={{
              '&:focus': {
                borderColor: '#9531FF',
                outline: 'none',
                boxShadow: 'none',
              },
            }}
          />
        </Box>
      )}
    </>
  );
};

export default ProjectJobList;
